export default __webpack_public_path__ + "static/media/exclusive_paper.8346c08e.png";